import { Component, inject } from '@angular/core';
import {Breadcrumb, BreadcrumbModule } from 'primeng/breadcrumb';
import { BreadcrumbService } from '../breadcrumb.service';

@Component({
  selector: 'app-top-bar',

  imports: [Breadcrumb],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.css'
})
export class TopBarComponent {
  private breadcrumbService = inject(BreadcrumbService);

  breadcrumbItems = this.breadcrumbService.getBreadcrumbs();
  home = this.breadcrumbService.getHome();
  breadcrumbStyle = {
    colorScheme: {
      light: {
        root: {
          background: "none",
        },
      },
    },
  };

}
